var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48,
    viewBox: "0 0 40 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-security_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7935F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B42FBC"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0l19 5.86v11.449c0 9.728-4.8 18.854-12.854 24.476l-.255.176L19 46l-5.892-4.04C4.987 36.366.102 27.284.002 17.614L0 17.31V5.859L19 0zm0 1L1 6.578v10.769c0 9.32 4.549 18.114 12.197 23.646l.253.18.255.18L19 45l5.296-3.648c7.784-5.342 12.5-14.051 12.698-23.392l.005-.308.002-.305V6.577L19 1zm.5 8C25.841 9 31 14.159 31 20.5S25.841 32 19.5 32 8 26.841 8 20.5 13.159 9 19.5 9zm3.545 16h-7.09c-1.586 0-2.883.987-2.952 2.22l-.003.103v1.417a10.479 10.479 0 0012.812.144L26 28.74v-1.417c0-1.246-1.255-2.266-2.823-2.32L23.045 25zM19.5 10C13.71 10 9 14.776 9 20.647c0 2.766 1.047 5.287 2.76 7.182l.157.171v-.33c0-1.877 1.757-3.41 3.946-3.472l.137-.002h7c2.206 0 4.008 1.495 4.081 3.357l.002.117V28A10.685 10.685 0 0030 20.647C30 14.777 25.29 10 19.5 10zm-.5 4c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 1c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z",
    transform: "translate(1 1)",
    fill: "#333",
    stroke: "url(#icon-security_svg__a)",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "6126095082316215a4e3224dded3a121.svg";
export { SvgIconSecurity as ReactComponent };